interface Props {
  width?: number | string;
  height?: number | string;
  borderRadius?: string;
  style?: React.CSSProperties;
}

export function Skeleton({ width = "100%", height = 14, borderRadius = "var(--radius-md)", style }: Props) {
  return (
    <div
      className="animate-pulse"
      style={{ width, height, borderRadius, background: "var(--color-surface-100)", flexShrink: 0, ...style }}
    />
  );
}
